import SelectReport from '../components/SelectAggReport';
import * as actions from './../../common/actions';
import { StoreState } from './../../common/types/index';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

export function mapStateToProps({ query }: StoreState.All) {
  return {
    selectedAggReport: query.aggReport,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    onChange: (aggReport: any) => dispatch(actions.updateAggReport(aggReport)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectReport);
